// Z-Order-Verwaltung — Render-Sort nutzt (zOrder ?? 0, createdAt).
// V2 Slice 3. Operiert auf Y.Map in einer Transaction damit Undo 1-Schritt-saubere bleibt.

import { isCanvasObject } from "@ms-whiteboard/shared";
import type * as Y from "yjs";

function readAllZOrders(yMap: Y.Map<unknown>): number[] {
  const result: number[] = [];
  for (const value of yMap.values()) {
    if (!isCanvasObject(value)) continue;
    result.push(value.zOrder ?? 0);
  }
  return result;
}

function setOrder(yMap: Y.Map<unknown>, id: string, next: number): void {
  const raw = yMap.get(id);
  if (!isCanvasObject(raw)) return;
  if ((raw.zOrder ?? 0) === next) return;
  yMap.set(id, { ...raw, zOrder: next });
}

export function bringToFront(yMap: Y.Map<unknown>, ids: Iterable<string>): void {
  const max = Math.max(0, ...readAllZOrders(yMap));
  yMap.doc?.transact(() => {
    let cursor = max + 1;
    for (const id of ids) {
      setOrder(yMap, id, cursor);
      cursor += 1;
    }
  });
}

export function sendToBack(yMap: Y.Map<unknown>, ids: Iterable<string>): void {
  const min = Math.min(0, ...readAllZOrders(yMap));
  yMap.doc?.transact(() => {
    let cursor = min - 1;
    for (const id of ids) {
      setOrder(yMap, id, cursor);
      cursor -= 1;
    }
  });
}

export function bringForward(yMap: Y.Map<unknown>, ids: Iterable<string>): void {
  yMap.doc?.transact(() => {
    for (const id of ids) {
      const raw = yMap.get(id);
      if (!isCanvasObject(raw)) continue;
      setOrder(yMap, id, (raw.zOrder ?? 0) + 1);
    }
  });
}

export function sendBackward(yMap: Y.Map<unknown>, ids: Iterable<string>): void {
  yMap.doc?.transact(() => {
    for (const id of ids) {
      const raw = yMap.get(id);
      if (!isCanvasObject(raw)) continue;
      setOrder(yMap, id, (raw.zOrder ?? 0) - 1);
    }
  });
}
